import { Form, Select } from 'antd'
import React from 'react'

import type { OutageMetadataBaseItem } from '../types'
import { formatSelectOptions, sortMetadataOptionsAlphabetically } from '../util'

type SelectInputProps = {
  title: string
  name: string
  options: string[] | OutageMetadataBaseItem[] | undefined
  isRequired?: boolean
}

export function SelectInput({ title, name, options = [], isRequired = false }: SelectInputProps) {
  return (
    <Form.Item
      label={title}
      name={name}
      required={isRequired}
      rules={[{ required: isRequired, message: `${title} is required` }]}
    >
      <Select
        showSearch
        placeholder={`Select ${title}`}
        labelInValue
        options={options.sort(sortMetadataOptionsAlphabetically).map(formatSelectOptions)}
        allowClear
        filterOption={(input, option) => (option?.search ?? '').toLowerCase().includes(input.toLowerCase())}
      />
    </Form.Item>
  )
}
